import React from 'react';
import ReactDOM from 'react-dom/client';
// Локальные шрифты Inter (self-hosted, без запросов к fonts.googleapis.com).
// Набор весов соответствует прежнему Google Fonts импорту: 300–800 + italic 400.
import '@fontsource/inter/300.css';
import '@fontsource/inter/400.css';
import '@fontsource/inter/400-italic.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import '@fontsource/inter/800.css';
import './index.scss';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
